
import { Component, computed, inject, input, signal } from '@angular/core'

import { Store } from '@ngrx/store'

import { AiAgent, GeneratingItem, ChatMessage } from '@flowx/designer/modules/ai/types/ai.types'

import { AiSelectors } from '../../../../store/ai.selectors'
import { AiService } from '../../../../store/ai.service'

const MAX_GENERATORS = 4

@Component({
  selector: 'flx-ai-msg-file-generators',
  imports: [],
  templateUrl: './ai-msg-file-generators.component.html',
  styleUrl: './ai-msg-file-generators.component.scss',
})
export class AiMsgFileGeneratorsComponent {
  #store = inject(Store)
  #aiService = inject(AiService)

  generators = input<ChatMessage['generators']>()

  displayedGenerators = computed(() => {
    const generators = this.generators()
    const isExpandedGenerators = this.isExpandedGenerators()

    const items = generators?.items?.map((item) => ({ ...item, expandedDescription: false })) ?? []
    let label = ''
    switch (generators?.agent) {
      case AiAgent.ANALYST:
        label = 'processes'
        break
      case AiAgent.DESIGNER:
        label = 'designs'
        break
      case AiAgent.DEVELOPER:
        label = 'business rules'
        break
    }

    return {
      summary: generators?.summary,
      label,
      items: items.slice(0, isExpandedGenerators ? undefined : MAX_GENERATORS),
      count: items.length,
    }
  })

  isGenerateFromDocumentContextDisabled = computed(
    () =>
      this.generators()?.documentId !==
        this.#store.selectSignal(AiSelectors.selectedDocument)()?.documentId ||
      this.#store.selectSignal(AiSelectors.isGenerateFromDocumentContextDisabled)()
  )

  isManualExpandedGenerators = signal(false)

  collapsedGeneratorsLimitReached = computed(() => {
    const generators = this.generators()
    const generatorsNo = generators?.items?.length
    return generatorsNo <= MAX_GENERATORS
  })

  isExpandedGenerators = computed(
    () => this.isManualExpandedGenerators() || this.collapsedGeneratorsLimitReached()
  )

  isMultiLineOverflows(el: HTMLElement): boolean {
    return el.scrollHeight > el.clientHeight
  }

  generateFromDocument(generator: GeneratingItem): void {
    const documentContextReference = {
      name: generator.value,
      documentId: this.generators().documentId,
    }

    this.#aiService.generateFromDocument(documentContextReference)
  }

  showAllGenerators(): void {
    this.isManualExpandedGenerators.set(true)
  }
}
